module.exports = __webpack_public_path__ + "static/img/contant_1.76fd523.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_13/contant_1.jpg
// module id = ZUh5
// module chunks = 0